import { render } from "./QPencilSimple.vue?vue&type=template&id=5efe93dc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QPencilSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5efe93dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5efe93dc', __exports__)) {
    api.reload('5efe93dc', __exports__)
  }
  
  module.hot.accept("./QPencilSimple.vue?vue&type=template&id=5efe93dc", () => {
    api.rerender('5efe93dc', render)
  })

}


export default __exports__